import React, {useEffect, useState} from "react";
import { getUsersTrainingsLists } from "../../service";
import useUserInfo from "../../routers/useUserInfo";
import bg from '../../images/logo-bg.png'
import Pagination from "../../components/pagination";
import usePagination from "../../routers/usePagination";
import {TrainingsData} from "../types";
import {dateFormat} from "../../units";
import {Link} from "react-router-dom";
import CommonTitle from "../../components/common-title";
import Empty from "../../components/empty";

function MineOffline() {

    const userData = useUserInfo()
    const [lists,setLists] = useState<Array<TrainingsData>>([])
    const [waitLists,setWaitLists] = useState<Array<TrainingsData>>([])
    const [nowLists,setNowLists] = useState<Array<TrainingsData>>([])
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore } = usePagination();

    useEffect(() => {
        if(userData){
            getUsersTrainingsLists({
                userId:userData.id,
                pageNum:1,
                status:0
            }).then(res => {
                const lists = res.data.list
                setWaitLists(lists)
            })
        }
        if(userData){
            getUsersTrainingsLists({
                userId:userData.id,
                pageNum:1,
                status:1
            }).then(res => {
                const lists = res.data.list
                setNowLists(lists)
            })
        }
    },[])

    useEffect(() =>{
       if(userData){
           getUsersTrainingsLists({
               userId:userData.id,
               pageNum,
               status:2
           }).then(res => {
               const lists = res.data.list
               if((lists as Array<TrainingsData>).length > 0){
                   setLists(list => list.concat(lists))
               }else{
                   noMore()
               }
           })
       }
    },[pageNum])


    return <div className="user-active">
        <CommonTitle title={"线下课申请记录"}/>
        {
            (lists.length === 0 && nowLists.length === 0 && waitLists.length === 0) || <p className="tip">* 温馨提示：您的申请已收到,BG导师助理将联系您办理入学</p>
        }

        <div className="lists">
            {
                waitLists.map((item,index) => {
                    return <div className="item" key={index}>
                        <div className="img-box">
                            <div className="text" style={{ backgroundImage:`url(${ bg })` }}>
                                <h3>
                                    { item.trainTitle }
                                </h3>
                                <div className="flex">
                                    <p className="date">授课期：{ dateFormat(item.startTime) } 至 { dateFormat(item.endTime) }</p>
                                    <p className="status">待开课</p>
                                </div>
                            </div>
                        </div>
                        <div className="b">
                            <div className="l">{ item.threshold }</div>
                            {/*<p className="iconfont">&#xe608;</p>*/}
                        </div>
                    </div>
                })
            }
            {
                nowLists.map((item,index) => {
                    return <div className="item" key={index}>
                        <div className="img-box">
                            <div className="text" style={{ backgroundImage:`url(${ bg })` }}>
                                <h3>
                                    { item.trainTitle }
                                </h3>
                                <div className="flex">
                                    <p className="date">授课期：{ dateFormat(item.startTime) } 至 { dateFormat(item.endTime) }</p>
                                    <p className="status">课程已开课</p>
                                </div>
                            </div>
                        </div>
                        <div className="b">
                            <div className="l">{ item.threshold }</div>
                            {/*<p className="iconfont">&#xe608;</p>*/}
                        </div>
                    </div>
                })
            }
            {
                lists.map((item,index) => {
                    return <div className="item" key={index}>
                        <div className="img-box">
                            <div className="text" style={{ backgroundImage:`url(${ bg })` }}>
                                <h3>
                                    { item.trainTitle }
                                </h3>
                                <div className="flex">
                                    <p className="date">授课期：{ dateFormat(item.startTime) } 至 { dateFormat(item.endTime) }</p>
                                    <p className="status">已结课</p>
                                </div>
                            </div>
                        </div>
                        <div className="b">
                            <div className="l">{ item.threshold }</div>
                            {/*<p className="iconfont">&#xe608;</p>*/}
                        </div>
                    </div>
                })
            }
        </div>
        <Pagination noEmpty ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
        {
            (lists.length === 0 && nowLists.length === 0 && waitLists.length === 0) && <Empty>暂无数据</Empty>
        }
    </div>
}

export default MineOffline;
